import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetEdc_sharing_groupIdInvoices_invoiceIdDownload = z.any()
export type TagsGetEdc_sharing_groupIdInvoices_invoiceIdDownload = z.infer<typeof tagsGetEdc_sharing_groupIdInvoices_invoiceIdDownload>

export const paramsGetEdc_sharing_groupIdInvoices_invoiceIdDownload = z.object({ "groupId": z.string(), "invoiceId": z.string() })
export type ParamsGetEdc_sharing_groupIdInvoices_invoiceIdDownload = z.infer<typeof paramsGetEdc_sharing_groupIdInvoices_invoiceIdDownload>

export const responseGetEdc_sharing_groupIdInvoices_invoiceIdDownload = z.any()
export type ResponseGetEdc_sharing_groupIdInvoices_invoiceIdDownload = z.infer<typeof responseGetEdc_sharing_groupIdInvoices_invoiceIdDownload>

interface IGetEdc_sharing_groupIdInvoices_invoiceIdDownload extends BaseMethodType {
  tags: TagsGetEdc_sharing_groupIdInvoices_invoiceIdDownload,
  params: ParamsGetEdc_sharing_groupIdInvoices_invoiceIdDownload,
  response: ResponseGetEdc_sharing_groupIdInvoices_invoiceIdDownload
}
export const URL = '/edc-sharing/:groupId/invoices/:invoiceId/download'
export const validation = {
  get: {
    tags: tagsGetEdc_sharing_groupIdInvoices_invoiceIdDownload,
    params: paramsGetEdc_sharing_groupIdInvoices_invoiceIdDownload,
    response: responseGetEdc_sharing_groupIdInvoices_invoiceIdDownload
  }
}
export interface Edc_sharing_groupIdInvoices_invoiceIdDownload extends BaseRouteType {
  get: IGetEdc_sharing_groupIdInvoices_invoiceIdDownload
}